'use strict';

/**
 *
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabem@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var GroupModel = require('../../models/group');

var template = require('modules/community/templates/partials/group-form.hbs');

var GroupForm = ItemView.extend({
    template: template,

    tagName: 'form',

    className: 'group-edit-form',

    ui: {
        'groupName': '[name="groupName"]',
        'contactInputs': '[name="contacts[]"]',
        'groupSubmit': '[data-action="group-submit"]',
    },

    events: {
        'submit': 'onSubmit',
    },

    viewData: {
        possibleContacts: function() {
            return this.getPossibleContacts();
        },
    },

    templateHelpers: {
        t: function() {
            if (this.model.get('type') === 'broadcast') {
                var translationKey = arguments[0];
                var broadcastLabels = {
                    'community::group:input:label:name': 'community::broadcast:input:label:name',
                    'community::group:input:placeholder:name': 'community::broadcast:input:placeholder:name',
                    'community::group:legend:contacts': 'community::broadcast:legend:contacts',
                    'community::group:button:label:create:submit': 'community::broadcast:button:label:create:submit',
                };

                if (_.has(broadcastLabels, translationKey)) {
                    arguments[0] = broadcastLabels[translationKey];
                }
            }

            return App.t.apply(App, arguments);
        },
    },

    initialize: function() {
        if (!this.model) {
            this.model = new GroupModel();
        }

        this.collection = App.CommunityModule.groupsCollection;
        this.contacts = App.CommunityModule.contactsCollection;
    },

    onAttach: function() {
        setTimeout(function(){
            this.ui.groupName.focus();
        }.bind(this), 0);
    },

    onSubmit: function(event) {
        event ? event.preventDefault() : null;

        var groupName = this.ui.groupName.val().trim();
        var userIds = _.map(this.ui.contactInputs.filter('[type="hidden"], :checked'), function(input){
            return parseInt($(input).val(), 10);
        });

        if (groupName.length && userIds.length) {
            this.disableSubmit();

            this.model.save({
                name: groupName,
                users: _.map(userIds, function(userId){ return {id: userId}; }),
            }, {
                patch: true,
                success: function() {
                    this.enableSubmit();
                    this.collection.add(this.model);
                    this.trigger('group:saved');
                }.bind(this),
                error: function() {
                    this.enableSubmit();
                }.bind(this),
            })
        } else {
            Messenger().error({
                message: App.t('community::group:response:invalid-form'),
            });
        }
    },

    disableSubmit: function() {
        this.ui.groupSubmit.prop('disabled', true).addClass('is-loading');
    },

    enableSubmit: function() {
        this.ui.groupSubmit.prop('disabled', false).removeClass('is-loading');
    },

    getPossibleContacts: function() {
        var possibleContacts = []

        if (this.contacts && this.contacts.length) {
            var groupMembers = this.model.get('users');
            var groupMemberIds = _.pluck(groupMembers, 'id')
            var acceptedContacts = this.contacts.where({accepted: 'YES'});

            if (this.model.get('type') === 'broadcast') { //for broadcast groups you can add and remove contacts
                possibleContacts = _.map(acceptedContacts, function(contact){
                    contact.isChecked = _.contains(groupMemberIds, contact.get('userId'));

                    return contact;
                });
            } else { //for normal groups you can only add contacts
                possibleContacts = _.filter(acceptedContacts, function(contact) {
                    return !_.contains(groupMemberIds, contact.get('userId'));
                });
            }
        }

        return possibleContacts;
    },
});

module.exports = GroupForm;